import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { HeroContainer, HeroContent, HeroTitle, HeroSubtitle, StatsContainer, StatItem } from './styles';

const Hero: React.FC = () => {
  const { language } = useLanguage();
  return (
    <HeroContainer>
      <div className="container">
        <HeroContent>
          <HeroTitle>TECH BY TECH</HeroTitle>
          <HeroSubtitle>
            {language === 'pt' 
              ? 'INOVAÇÃO E EXCELÊNCIA EM SOLUÇÕES TECNOLÓGICAS'
              : 'INNOVATION AND EXCELLENCE IN TECHNOLOGICAL SOLUTIONS'}
          </HeroSubtitle>
          
          <StatsContainer>
            <StatItem>
              <h3>+5</h3>
              <p>{language === 'pt' ? 'ANOS DE EXPERIÊNCIA' : 'YEARS OF EXPERIENCE'}</p>
            </StatItem>
            <StatItem>
              <h3>22</h3>
              <p>{language === 'pt' ? 'PROJETOS CONCLUÍDOS' : 'COMPLETED PROJECTS'}</p>
            </StatItem>
            <StatItem>
              <h3>30</h3>
              <p>{language === 'pt' ? 'CLIENTES SATISFEITOS' : 'SATISFIED CLIENTS'}</p>
            </StatItem>
            <StatItem>
              <h3>40</h3>
              <p>{language === 'pt' ? 'SOLUÇÕES INOVADORAS' : 'INNOVATIVE SOLUTIONS'}</p>
            </StatItem>
          </StatsContainer>
        </HeroContent>
      </div>
    </HeroContainer>
  );
};

export default Hero;